// extracted by mini-css-extract-plugin
export default {"root":"CommissionSegment_root__ArVlX"};